GP.views.ActivityListItem = Backbone.Marionette.ItemView.extend({
    initialize:function(opts) {
        // re-render itemview on model change
        this.listenTo(this.model, 'change', this.render);

        var regex = new RegExp('divider*', 'g');
        var is_divider = regex.test(this.model.get('type'));

        if (!is_divider) {
            this.user = GP.sdata.ActivityUsers.get(this.model.get('duid'));
        }

        this.event_ns = opts.event_ns;
    },    
    template: function(serialized_data) {
        if (serialized_data.activity.type === 'divider_recent') {
            GP.activity_divider.recent = true;
            GP.activity_template = 'recent';
            return template('activity-divider-recent', serialized_data);
        } else if (serialized_data.activity.type === 'divider_older') {
            GP.activity_divider.older = true;
            GP.activity_template = 'older';
            return template('activity-divider-older', serialized_data);
        } else if (serialized_data.activity.type === 'divider_upgrade') {
            GP.activity_divider.upgrade = true;
            GP.activity_template = 'upgrade';
            return template('activity-divider-upgrade', serialized_data);
        } else {
            GP.activity_template = 'default';
            return template('activity-item', serialized_data);
        }
    },
    className: 'activity-item media-item',
    events: {
        'click .user-thumb':'open_profile',
        'click .info-wrap': 'open_content_or_thread'
    },
    templateHelpers: {
        user_online: function() {
            return (this.user && this.user.online_status == 'ONLINE') ? '' : 'hide';
        },
        is_verified: function() {
            return (this.user.verified_pic === 'Y');
        },
        self_view: function() {
            return parseInt(this.user.duid) === parseInt(GP.sdata.my_user.duid);
        }
    },
    open_profile: function(evnt) {
        if (this.user) {
            GP.vent.trigger('Page:redirect',this.user.url());
        }
        GP.vent.trigger('RightDrawer:close_if_mobile');
    },
    open_content_or_thread: function(evnt) {
        evnt.stopPropagation();

        var content_id = this.model.get('content_id');
        var content_duid = this.model.get('content_duid');
        var free_user = (GP.sdata.my_user.membership == 'FREE') ? true : false;
        var billing_url = this.model.get('billing_url');
        var activity_type = this.model.get('type');
        var activity_user_duid = this.user.get('duid');

        // redirect to billing_url if free user, activity is a free_growl and we have a billing_url to redirect to
        if (activity_type == 'free_growl' && free_user && billing_url) {
            window.location.replace(billing_url);
        } else if (content_id) {
            if (MoshPit.get_size() == 'mobile') {
                localStorage.setItem('right_drawer_scrolltop', window.scrollY);
            }

            // reset scroll position on modal close for mobile
            if (MoshPit.get_size() == 'mobile') {
                $(document).one('fl_modal_closed', function() {
                    var scrolltop = localStorage.getItem("right_drawer_scrolltop");
                    if (scrolltop) {
                        window.scroll(0, parseInt(scrolltop, 10));
                    }
                });
            }

            // show the content viewer modal
            GP.vent.trigger('ContentViewer:show_content', content_id, content_duid);
        } else if (this.user) {
            // returns a promise, so add the done/fail callbacks here
            this.user.thread_json()
                .done(function(thread_json) {
                    if (GP.Util.check_obj(thread_json)) {
                        // GP.vent.trigger('MessagePane.Inbox:load_thread_external', thread_json);
                        if (MoshPit.get_size() == 'mobile') {
                            localStorage.setItem('right_drawer_scrolltop', window.scrollY);
                            thread_json.opened_from = 'activity';
                        }

                        GP.vent.trigger('MessagePane:send_message', activity_user_duid, thread_json);
                    }
                })
                .fail(function() {});
        }
    },
    onRender: function() {
        var classname = "activity-type-" + this.model.get('type').replace('_', '-');
        if (GP.activity_template === 'recent' || GP.activity_template === 'older') {
            this.$el.removeClass().addClass('activity-divider-wrap');
        } else {
            this.$el.addClass(classname);
        }
    },
    // return data to pass to handlebar template
    serializeData: function() {
        var tdata = {
            activity: this.model.toJSON(),
            user:     this.user ? this.user.toJSON() : {}
        };

        // force small pic
        if (typeof tdata.user.pic !== 'undefined' && tdata.user.pic != null) {
            tdata.user.pic = tdata.user.pic.replace('-M.jpg', '-S.jpg');
        }

        return tdata;
    }
});


GP.views.ActivityList = Backbone.Marionette.CollectionView.extend({
    childView: GP.views.ActivityListItem,
    emptyView: GP.views.NoResultsItemView.extend({
        template: function() {
            return js_lang.no_activities;
        }
    }),
    addChild: function(activity_model, ChildView, index) {
        var user_check = GP.sdata.ActivityUsers.get(activity_model.get('duid'));
        var regex = new RegExp('divider*', 'g');
        var is_divider = regex.test(activity_model.get('type'));

        if (user_check || is_divider) {
            return Marionette.CollectionView.prototype.addChild.call(this, activity_model, ChildView, index);
        }
    }
});
